import { db } from "common/config/Firebase"

const indicatorsByDay = db.collection('indicatorsByDay')
const indicatorsByMonth = db.collection('indicatorsByMonth')

const getAllIndicatorsByDay = async () => {
    const snapshot = await indicatorsByDay.get()

    return snapshot.docs.map(doc => {
        return { ...doc.data(), id: doc.id }
    })
}

const getAllIndicatorsByMonth = async () => {
    const snapshot = await indicatorsByMonth.get()

    return snapshot.docs.map(doc => {
        return { ...doc.data(), id: doc.id }
    })
}

export {
    getAllIndicatorsByDay,
    getAllIndicatorsByMonth
}